import Checklist from "@swivu/shared-ui/src/components/checklists/Checklist.js";
import { queryClient } from "../lib/queryClient.js";
import { useParams } from "react-router-dom";

const ViewChecklistItem = () => {
  const { checklist_id, slug } = useParams<{
    checklist_id?: string;
    slug?: string;
  }>();

  return (
    <Checklist.Provider
      queryClient={queryClient}
      api="public"
      checklist_id={Number(checklist_id)}
      slug={slug!}
    >
      <Checklist />
    </Checklist.Provider>
  );
};

export default ViewChecklistItem;
